module.exports = __webpack_public_path__ + "static/evergreen-toaster-08034a07e5725877f388dbc79fc6c825.png";